<template>
    <div>
      <select class="form-control" :value="value" :disabled="disabled" @change="$emit('change', $event.target.value)">
          <option value="" selected>{{placeholder}}</option>
        <slot></slot>
      </select>
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    value: {
      type: [String, Number, Boolean],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  select {
    color: rgb(120, 120, 120);
    cursor: pointer;
  }
</style>
